import HomeschoolBaseTile from 'teacher-ui-client/components/home/tiles/homeschool/base-tile'
import { t } from 'ember-intl'
import { TileButton } from 'teacher-ui-client/components/home/tiles/homeschool/button'
import library from '@images/homeschool-ui-icons/library_green.svg'
import type { TOC } from '@ember/component/template-only'
import { ThemeKeys } from 'teacher-ui-client/utils/themes'

export const TeacherLibraryTile: TOC<unknown> = <template>
  <HomeschoolBaseTile
    @themeKey={{ThemeKeys.blue}}
    @imgSrc={{library}}
    @imgAlt={{t "pages.home.panels.homeschool.teacherLibrary.imageAlt"}}
    @title={{t "pages.home.panels.homeschool.teacherLibrary.title"}}
    @tileDescription={{t "pages.home.panels.homeschool.teacherLibrary.description" htmlSafe=true}}
  >
    <div class="flex flex-col items-center space-y-4 text-center">
      <TileButton
        @title={{t "pages.home.panels.homeschool.teacherLibrary.buttonText"}}
        @themeKey={{ThemeKeys.blue}}
        @route="subscription-type.book-library.search"
        data-test-homeschool-teacher-library-button
      />
    </div>
  </HomeschoolBaseTile>
</template>

export default TeacherLibraryTile
